import axios from 'axios'

function handleResponse(response) {
	if (response.hasOwnProperty("data")) {
		if (response.data.hasOwnProperty("data")) {
			return [undefined, response.data.data]
		}
		return [undefined, response.data]
	}

	if (response.hasOwnProperty("results")) {
		return [undefined, response.results]
	}
	return [undefined, response]
}

function handleError(error) {
	if (error && error?.response?.status === 401) {
		// sessionStorage.clear()
		// delete axios.defaults.headers.common['Authorization']
		// window.location.assign('/login')
	}
	if(error?.response?.status === 404) {
		return ["Your account has limited access rights. Please contact your administrator for assistance.", undefined]
	}
	if (error?.response?.data?.error) {
		return [error.response.data.error, undefined]
	}
	if (error?.response?.data?.data?.error) {
		return [error.response.data.data.error, undefined]
	}
	else {
		return [error, undefined]
	}
}

function handleErrorWithoutRedirect (error){
	if (error?.response?.data?.error) {
		return [error.response.data.error, undefined]
	}
	else {
		return [error, undefined]
	}
}

export { handleResponse, handleError, handleErrorWithoutRedirect }
